
import React from 'react';

const categories = [
  { id: 'novelty', name: 'Novelty Items', icon: 'ri-gift-line' },
  { id: 'kratom', name: 'Kratom', icon: 'ri-leaf-line' },
  { id: 'vaporizers', name: 'Vaporizers', icon: 'ri-cloud-line' },
  { id: 'cigars', name: 'Cigars / Rolling Papers', icon: 'ri-fire-line' },
  { id: 'vapes', name: 'Vapes / Disposables / Ejuice', icon: 'ri-battery-charge-line' },
  { id: 'hemp', name: 'Hemp', icon: 'ri-plant-line' },
  { id: 'pipes', name: 'Pipes / Water Pipes', icon: 'ri-flask-line' },
  { id: 'apparel', name: 'Apparel', icon: 'ri-t-shirt-line' },
];

export default function ProductGrid() {
  return (
    <section className="py-20 bg-deep-black">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <h2 className="font-serif text-4xl lg:text-5xl text-white text-center mb-4 tracking-wide uppercase">
          What We Sell
        </h2>
        <div className="w-16 h-0.5 bg-copper mx-auto mb-14"></div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
          {Array.isArray(categories) &&
            categories.map((cat) => (
              <div
                key={cat.id}
                className="group bg-forest-green/80 border border-copper/10 rounded-2xl flex flex-col items-center justify-center py-10 px-4 hover:border-copper/40 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
              >
                <div className="w-16 h-16 flex items-center justify-center mb-5 text-white/90 group-hover:text-copper transition-colors duration-300">
                  <i className={`${cat.icon} text-5xl`}></i>
                </div>
                <span className="text-white font-semibold text-sm tracking-widest uppercase text-center leading-snug group-hover:text-copper transition-colors duration-300">
                  {cat.name}
                </span>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
}
